import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/financeiro/forma_pagamentos_recebimentos${queryUrl}`)
  },
  insertNewPaymentMethods(data) {
    return axios.post('/financeiro/forma_pagamentos_recebimentos', data)
  },
  editPaymentMethods(data) {
    return axios.put(`/financeiro/forma_pagamentos_recebimentos/${data.id}`, data)
  },
  deletePaymentMethods(id) {
    return axios.delete(`/financeiro/forma_pagamentos_recebimentos/${id}`)
  },
}
